import cn from "classnames"
import React from "react"
import "./LayoutSeparator.scss"

interface ILayoutSeparatorProps {
    hide?: boolean
}

export const LayoutSeparator = ({ hide }: ILayoutSeparatorProps) => {
    return <div className={cn("layout-separator", hide && "layout-separator--hidden")}></div>
}
